import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-insure-manage',
    templateUrl: './insure-manage.component.html',
    styleUrls: ['./insure-manage.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InsureManageComponent {

}
